<template>
  <div v-if="getProfile && getProfile.isAdmin" class="panel is-danger p-0">
    <p class="panel-heading">Admin Panel</p>

    <section
      class="is-flex is-justify-content-space-between"
      style="border-bottom: 2px solid grey;"
    >
      <div class="is-flex">
        <b-radio-button
          v-for="t in ticketStats"
          :key="t.status"
          v-model="selectedStatus"
          :type="t.type"
          :native-value="t.status"
        >
          <span>{{ t.status }} ({{ t.count }})</span>
        </b-radio-button>
      </div>

      <b-select v-model="filterType">
        <option value="" key="all">All</option>
        <option value="Wrong game result" key="status1">
          Wrong game result
        </option>
        <option value="Opponent cheated" key="status2">Opponent cheated</option>
        <option value="Others" key="status3">Others</option>
      </b-select>
    </section>

    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th style="width: 10%">Reported by</th>
          <th style="width: 15%">Issue</th>
          <th style="width: 40%">Description</th>
          <th style="width: 15%">Meta</th>
          <th style="width: 10%">Status</th>
          <th style="width: 10%">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in selectedTickets" :key="item.id">
          <td>
            {{ item.reportedBy }}
            <p>{{ item.date | asDate }}</p>
          </td>

          <td>
            <a v-if="item.url" :href="item.url">{{ item.type }}</a>
            <p v-if="item.move">Move: {{ item.move }}</p>
          </td>

          <td class="has-text-left">
            <p style="word-break: break-word;">{{ item.description }}</p>
            <p v-if="item.response" style="word-break: break-word;">
              <b>Response:</b>
              <i class="has-text-info">{{ item.response }}</i>
            </p>
          </td>

          <td>
            <div v-if="item.meta">
              <p
                v-if="item.meta.bindFirestore === false"
                class="has-text-danger"
              >
                Not bind firestore
              </p>
              <p v-if="item.meta.firestoreTimeOffset">
                time offset:
                {{ item.meta.firestoreTimeOffset.toFixed(1) }}s
              </p>
              <p v-if="item.meta.moveTime">
                move time: {{ item.meta.moveTime.toFixed(1) }}s
              </p>
            </div>
          </td>

          <td>
            <b-select
              v-model="item.status"
              @change.native="(e) => updateStatus(item, e.target.value)"
            >
              <option
                v-for="option in ['created', 'pending', 'resolved', 'deleted']"
                :value="option"
                :key="option"
                :disabled="item.status === option"
              >
                {{ option }}
              </option>
            </b-select>
          </td>

          <td>
            <b-tooltip label="Edit response">
              <b-button icon-right="pen" @click="handleEdit(item)" />
            </b-tooltip>

            <b-tooltip
              v-if="selectedStatus === 'deleted'"
              label="Permanently delete ticket"
              type="is-danger"
            >
              <b-button
                type="is-danger"
                icon-right="trash"
                @click="handleDelete(item)"
              />
            </b-tooltip>
          </td>
        </tr>
      </tbody>
    </table>

    <b-modal
      v-model="isModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
    >
      <template #default="props">
        <TicketForm :ticket="ticket" @close="props.close" />
      </template>
    </b-modal>
  </div>
</template>

<script>
import TicketForm from "@/components/admins/TicketForm.vue";

import { firestore } from "@/services/firebase";
import { mapGetters } from "vuex";

const ticketsRef = firestore.collection("tickets");

export default {
  components: { TicketForm },

  name: "AdminTickets",

  data() {
    return {
      filterType: "",
      selectedStatus: "created",
      tickets: [],
      isModalActive: false,
      ticket: null,
    };
  },

  computed: {
    ...mapGetters(["getProfile"]),

    filters() {
      return { status: this.selectedStatus, type: this.filterType };
    },

    filteredTickets() {
      if (this.filterType) {
        return this.tickets.filter((t) => t.type === this.filterType);
      }
      return this.tickets;
    },

    ticketStats() {
      return [
        {
          status: "created",
          count: this.filteredTickets.filter((t) => t.status == "created")
            .length,
        },
        {
          status: "pending",
          type: "is-warning",
          count: this.filteredTickets.filter((t) => t.status == "pending")
            .length,
        },
        {
          status: "resolved",
          type: "is-success",
          count: this.filteredTickets.filter((t) => t.status == "resolved")
            .length,
        },
        {
          status: "deleted",
          type: "is-danger",
          count: this.filteredTickets.filter((t) => t.status == "deleted")
            .length,
        },
      ];
    },

    selectedTickets() {
      return this.filteredTickets.filter(
        (t) => t.status === this.selectedStatus
      );
    },
  },

  firestore: {
    tickets: ticketsRef.orderBy("date", "desc"),
  },

  watch: {
    filters: function() {
      if (
        this.$route.query.status !== this.selectedStatus ||
        this.$route.query.type !== this.filterType
      ) {
        const newQuery = { ...this.$route.query, ...this.filters };
        history.replaceState(
          {},
          null,
          "#" +
            this.$route.path +
            "?" +
            Object.keys(newQuery)
              .map((key) => {
                return (
                  encodeURIComponent(key) +
                  "=" +
                  encodeURIComponent(newQuery[key])
                );
              })
              .join("&")
        );
      }
    },
  },

  methods: {
    updateStatus(item, status) {
      if (!status) return;
      ticketsRef.doc(item.id).update({
        status: status,
      });
    },

    handleEdit(item) {
      this.ticket = item;
      this.isModalActive = true;
    },

    handleDelete(item) {
      ticketsRef.doc(item.id).delete();
    },
  },

  created() {
    if (this.$route.query.type) this.filterType = this.$route.query.type;
    if (this.$route.query.status) {
      this.selectedStatus = this.$route.query.status;
    }
  },
};
</script>

<style scoped></style>
